import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const KitchenConfigSection = ({ 
  kitchenConfig, 
  onKitchenConfigChange, 
  errors = {},
  isCollapsed = false,
  onToggleCollapse 
}) => {
  const handleInputChange = (field, value) => {
    onKitchenConfigChange({
      ...kitchenConfig,
      [field]: value
    });
  };

  const kitchenStyleOptions = [
    { value: 'simple', label: 'Simple' },
    { value: 'handleless', label: 'Sans poignées' }
  ];

  return (
    <div className="bg-surface border border-border rounded-lg">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-8 h-8 bg-accent rounded-full">
            <Icon name="Home" size={16} color="white" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-text-primary">Configuration Cuisine</h3>
            <p className="text-sm text-text-secondary">Style et éléments de la cuisine</p>
          </div>
        </div>
        <Icon 
          name={isCollapsed ? "ChevronDown" : "ChevronUp"} 
          size={20} 
          className="text-text-secondary" 
        />
      </div>
      {!isCollapsed && (
        <div className="px-4 pb-4 border-t border-border">
          <div className="space-y-4 mt-4">
            <Select
              label="Style de cuisine *"
              placeholder="Sélectionner le style"
              options={kitchenStyleOptions}
              value={kitchenConfig?.style || ''}
              onChange={(value) => handleInputChange('style', value)}
              error={errors?.style}
              required
            />

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <Input
                label="Meubles hauts"
                type="number"
                placeholder="0"
                min="0"
                value={kitchenConfig?.upperCabinets || ''}
                onChange={(e) => handleInputChange('upperCabinets', parseInt(e?.target?.value) || 0)}
                error={errors?.upperCabinets}
              />
              
              <Input
                label="Meubles bas"
                type="number"
                placeholder="0"
                min="0"
                value={kitchenConfig?.lowerCabinets || ''}
                onChange={(e) => handleInputChange('lowerCabinets', parseInt(e?.target?.value) || 0)}
                error={errors?.lowerCabinets}
              />
              
              <Input
                label="Colonnes"
                type="number"
                placeholder="0"
                min="0"
                value={kitchenConfig?.columns || ''}
                onChange={(e) => handleInputChange('columns', parseInt(e?.target?.value) || 0)}
                error={errors?.columns}
              />
              
              <Input
                label="Angles hauts"
                type="number"
                placeholder="0"
                min="0"
                value={kitchenConfig?.upperCorners || ''}
                onChange={(e) => handleInputChange('upperCorners', parseInt(e?.target?.value) || 0)}
                error={errors?.upperCorners}
              />
              
              <Input
                label="Angles bas"
                type="number"
                placeholder="0"
                min="0"
                value={kitchenConfig?.lowerCorners || ''}
                onChange={(e) => handleInputChange('lowerCorners', parseInt(e?.target?.value) || 0)}
                error={errors?.lowerCorners}
              />
              
              <Input
                label="Plinthes (ML)"
                type="number"
                placeholder="0"
                min="0"
                step="0.1"
                value={kitchenConfig?.baseboards || ''}
                onChange={(e) => handleInputChange('baseboards', parseFloat(e?.target?.value) || 0)}
                error={errors?.baseboards}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Input
                label="Jambages"
                type="number"
                placeholder="0"
                min="0"
                value={kitchenConfig?.jambs || ''}
                onChange={(e) => handleInputChange('jambs', parseInt(e?.target?.value) || 0)}
                error={errors?.jambs}
              />
              
              <Input
                label="Fillers"
                type="number"
                placeholder="0"
                min="0"
                value={kitchenConfig?.fillers || ''}
                onChange={(e) => handleInputChange('fillers', parseInt(e?.target?.value) || 0)}
                error={errors?.fillers}
              />
              
              <Input
                label="Joues"
                type="number"
                placeholder="0"
                min="0"
                value={kitchenConfig?.sidePanels || ''}
                onChange={(e) => handleInputChange('sidePanels', parseInt(e?.target?.value) || 0)}
                error={errors?.sidePanels}
              />
            </div>

            <Input
              label="Crédence (ML)"
              type="number"
              placeholder="0"
              min="0"
              step="0.1"
              value={kitchenConfig?.backsplash || ''}
              onChange={(e) => handleInputChange('backsplash', parseFloat(e?.target?.value) || 0)}
              error={errors?.backsplash}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default KitchenConfigSection;